import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCarousel,{staticClass:"host-main-slideshow",attrs:{"cycle":"","height":"477","hide-delimiter-background":"","show-arrows-on-hover":""}},[_c(VCarouselItem,[_c('Slide1')],1),_c(VCarouselItem,[_c('Slide2')],1),_c(VCarouselItem,[_c('Slide3')],1),_c(VCarouselItem,[_c('Slide4')],1),_c(VCarouselItem,[_c('Slide5')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }